export default __webpack_public_path__ + "static/media/staff.243d027a.jpeg";